import request from '@/utils/request';
import { loginCompany, loginOrg } from '@/utils/LoginContext';
import { async } from 'q';

export async function query(payload) {
  return request(`/iwms-wms/wms/process/page`, {
    method: 'POST',
    body: payload
  });
}

export async function get(payload) {
  return request(`/iwms-wms/wms/process/${payload.uuid}`);
}

export async function getByBillNumber(payload) {
  return request(`/iwms-wms/wms/process/${payload.billNumber}/get?dcUuid=${loginOrg().uuid}`);
}

export async function save(payload) {
  return request(`/iwms-wms/wms/process`, {
    method: 'POST',
    body: payload,
  });
}

export async function saveAndApprove(payload) {
  return request(`/iwms-wms/wms/process/saveAndAudit`, {
    method: 'POST',
    body: payload,
  });
}

export async function modify(payload) {
  return request(`/iwms-wms/wms/process/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function remove(payload) {
  return request(`/iwms-wms/wms/process/${payload.uuid}?version=${payload.version}`, {
    method: 'DELETE',
  });
}

export async function audit(payload) {
  return request(`/iwms-wms/wms/process/${payload.uuid}/audit?version=${payload.version}`, {
    method: 'POST',
  });
}

export async function queryProcessAbleStock(payload) {
  return request(`/iwms-wms/wms/process/queryStocks`, {
    method: 'POST',
    body: payload,
  });
}

export async function queryProcessEndArticles(payload) {
  return request(`/iwms-wms/wms/process/queryEndProducts?companyUuid=${loginCompany().uuid}&ownerUuid=${payload.ownerUuid}&articleCode=${payload.articleCode}&schemeUuid=${payload.schemeUuid}`, {
    method: 'GET'
  });
}

export async function queryContainers(payload) {
  return request(`/iwms-wms/wms/process/queryUsingOrIdelContainers?companyUuid=${loginCompany().uuid}&dcUuid=${loginOrg().uuid}&containerBarcode=${payload.containerBarCode}&articleUuid=${payload.articleUuid}&qpcStr=${payload.qpcStr}&productionBatch=${payload.productionBatch}&binCode=${payload.binCode}`, {
    method: 'GET'
  });
}

export async function abort(payload) {
  return request(`/iwms-wms/wms/process/abort/${payload.uuid}?version=${payload.version}`, {
    method: 'POST',
  });
}

export async function finish(payload) {
  return request(`/iwms-wms/wms/process/finish/${payload.uuid}?version=${payload.version}`, {
    method: 'POST',
  });
}

export async function adj(payload) {
  return request(`/iwms-wms/wms/process/adj/${payload.uuid}?version=${payload.version}`, {
    method: 'POST',
    body: payload.items
  });
}

export async function verifyLimit(payload) {
  return request(`/iwms-wms/wms/process/verifyLimit?companyUuid=${payload.companyUuid}&dcUuid=${payload.dcUuid}`, {
    method: 'POST',
    body: payload.entity
  });
}

export async function verifySave(payload) {
  return request(`/iwms-wms/wms/process/verifySave?companyUuid=${payload.companyUuid}&dcUuid=${payload.dcUuid}`, {
    method: 'POST',
    body: payload.entity
  });
}
//查询加工方案耗材原料库存数量
export async function queryConsumRawStocks(payload) {
  return request(`/iwms-wms/wms/process/queryConsumRawStocks`, {
    method: 'POST',
    body: payload
  });
}
